/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M4 5L4 19"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M16.0696 17.8304C17.6755 18.8628 18.4785 19.379 19.1425 19.3316C19.7211 19.2903 20.2534 18.9997 20.601 18.5353C21 18.0024 21 17.0478 21 15.1387V8.86133C21 6.95219 21 5.99762 20.601 5.46471C20.2534 5.0003 19.7211 4.70974 19.1425 4.66841C18.4785 4.62099 17.6755 5.13718 16.0696 6.16956L11.1872 9.30823C9.79366 10.2041 9.09688 10.652 8.85622 11.2216C8.64595 11.7192 8.64595 12.2808 8.85622 12.7784C9.09688 13.348 9.79366 13.7959 11.1872 14.6918L16.0696 17.8304Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M16.0696 17.8304C17.6755 18.8628 18.4785 19.379 19.1425 19.3316C19.7211 19.2903 20.2534 18.9997 20.601 18.5353C21 18.0024 21 17.0478 21 15.1387V8.86133C21 6.95219 21 5.99762 20.601 5.46471C20.2534 5.0003 19.7211 4.70974 19.1425 4.66841C18.4785 4.62099 17.6755 5.13718 16.0696 6.16956L11.1872 9.30823C9.79366 10.2041 9.09688 10.652 8.85622 11.2216C8.64595 11.7192 8.64595 12.2808 8.85622 12.7784C9.09688 13.348 9.79366 13.7959 11.1872 14.6918L16.0696 17.8304Z"
				fill="currentColor"
			/>
			<path
				d="M4 5L4 19M11.1872 14.6918L16.0696 17.8304C17.6755 18.8628 18.4785 19.379 19.1425 19.3316C19.7211 19.2903 20.2534 18.9997 20.601 18.5353C21 18.0024 21 17.0478 21 15.1387V8.86133C21 6.95219 21 5.99762 20.601 5.46471C20.2534 5.0003 19.7211 4.70974 19.1425 4.66841C18.4785 4.62099 17.6755 5.13718 16.0696 6.16956L11.1872 9.30823C9.79366 10.2041 9.09688 10.652 8.85622 11.2216C8.64595 11.7192 8.64595 12.2808 8.85622 12.7784C9.09688 13.348 9.79366 13.7959 11.1872 14.6918Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M19.1959 3.9203C18.6502 3.88132 18.1294 4.07997 17.613 4.34876C17.0979 4.61686 16.4719 5.01931 15.6964 5.51784L15.664 5.53865L10.7816 8.67732L10.7505 8.69734C10.0802 9.12825 9.53373 9.47952 9.12815 9.79582C8.71604 10.1172 8.3605 10.4678 8.16537 10.9296C7.87623 11.6139 7.87623 12.3861 8.16537 13.0703C8.3605 13.5322 8.71604 13.8827 9.12815 14.2041C9.53372 14.5204 10.0801 14.8717 10.7504 15.3026L10.7505 15.3026L10.7816 15.3226L15.664 18.4613L15.6964 18.4821L15.6964 18.4821C16.4719 18.9807 17.0979 19.3831 17.613 19.6512C18.1294 19.92 18.6502 20.1186 19.1959 20.0797C19.9916 20.0228 20.7234 19.6233 21.2014 18.9848C21.5293 18.5468 21.6438 18.0013 21.697 17.4215C21.75 16.8433 21.75 16.0991 21.75 15.1773V15.1772V15.1386V8.86131V8.82278V8.82269C21.75 7.90085 21.75 7.15668 21.697 6.57843C21.6438 5.99868 21.5293 5.45319 21.2014 5.0152C20.7234 4.37664 19.9916 3.97713 19.1959 3.9203ZM4.75 4.99998C4.75 4.58576 4.41421 4.24998 4 4.24998C3.58579 4.24998 3.25 4.58577 3.25 4.99998V19C3.25 19.4142 3.58579 19.75 4 19.75C4.41421 19.75 4.75 19.4142 4.75 19L4.75 4.99998Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M4 5L4 19M21 14V14.5V15.1387C21 17.0478 21 18.0024 20.601 18.5353C20.2534 18.9997 19.7211 19.2903 19.1425 19.3316C18.4785 19.379 17.6755 18.8628 16.0696 17.8304L11.1872 14.6918C9.79366 13.7959 9.09688 13.348 8.85622 12.7784C8.64595 12.2808 8.64595 11.7192 8.85622 11.2216C9.09688 10.652 9.79366 10.2041 11.1872 9.30823L11.6667 9L12 8.78571M21 10V9.5V8.86133C21 6.95219 21 5.99762 20.601 5.46471C20.2534 5.0003 19.7211 4.70974 19.1425 4.66841C18.4785 4.62099 17.6755 5.13718 16.0696 6.16956L15.5556 6.5L15 6.85714"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M4 5L4 19M11.1872 14.6918L16.0696 17.8304C17.6755 18.8628 18.4785 19.379 19.1425 19.3316C19.7211 19.2903 20.2534 18.9997 20.601 18.5353C21 18.0024 21 17.0478 21 15.1387V8.86133C21 6.95219 21 5.99762 20.601 5.46471C20.2534 5.0003 19.7211 4.70974 19.1425 4.66841C18.4785 4.62099 17.6755 5.13718 16.0696 6.16956L11.1872 9.30823C9.79366 10.2041 9.09688 10.652 8.85622 11.2216C8.64595 11.7192 8.64595 12.2808 8.85622 12.7784C9.09688 13.348 9.79366 13.7959 11.1872 14.6918Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M21.7502 8.95288C21.7502 6.56646 21.7502 5.37325 21.2515 4.70711C20.8169 4.1266 20.1517 3.7634 19.4283 3.71174C18.5983 3.65245 17.5946 4.29769 15.5872 5.58817L10.8473 8.63526C9.10535 9.75507 8.23439 10.315 7.93356 11.0269C7.67071 11.649 7.67071 12.3509 7.93356 12.973C8.23439 13.685 9.10535 14.2449 10.8473 15.3647L15.5872 18.4118C17.5946 19.7022 18.5983 20.3475 19.4283 20.2882C20.1517 20.2365 20.8169 19.8733 21.2515 19.2928C21.7502 18.6267 21.7502 17.4335 21.7502 15.0471V8.95288Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M4 4.25012C4.41421 4.25012 4.75 4.58591 4.75 5.00012L4.75 19.0001C4.75 19.4143 4.41421 19.7501 4 19.7501C3.58579 19.7501 3.25 19.4143 3.25 19.0001L3.25 5.00012C3.25 4.58591 3.58579 4.25012 4 4.25012Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
